module.exports = __webpack_public_path__ + "img/wcw-bridge.fbcc6a7.svg";